module.exports = __webpack_public_path__ + "resources/img/img_experdb3.83ff1940c2252ed7f6642f5a28ae726e.png";